import React from "react";
import { Pie } from "react-chartjs-2";

const RootCausePieChart = ({ data }) => {

  const chartData = {
    labels: data.map(d => d.cause),
    datasets: [
      {
        data: data.map(d => d.count),
        backgroundColor: [
          "#ef4444",
          "#f97316",
          "#eab308",
          "#22c55e",
          "#06b6d4"
        ]
      }
    ]
  };

  return (
    <div className="bg-gray-800 p-5 rounded-xl border border-gray-700">
      <h3 className="mb-4 font-semibold text-white">
        🧠 Root Cause of Sprint Delays
      </h3>

      <Pie data={chartData}/>
    </div>
  );
};

export default RootCausePieChart;